<section class="detail-shell">
  @if (loading() && !agent()) {
    <app-ui-detail-header-skeleton />
  } @else if (agent(); as currentAgent) {
    <app-ui-page-header
      backLabel="Agentes"
      backLink="/agentes"
      density="compact"
      [divider]="false"
      [title]="currentAgent.name || 'Agente'"
      [subtitle]="
        archetype()?.name || currentAgent.objective || currentAgent.goal || 'Agente configurado'
      "
    >
      <div actions class="detail-header-actions">
        <span appBadge [tone]="currentAgent.status === 'active' ? 'accent' : 'neutral'" size="sm">
          {{ statusLabel(currentAgent.status) }}
        </span>
        <span appBadge tone="neutral" size="sm">
          @if (currentVersion()) {
            versão atual v{{ currentVersion()?.version }}
          } @else {
            sem versão publicada
          }
        </span>
        <button appButton variant="ghost" size="sm" type="button" (click)="reload()">
          <ng-icon name="heroArrowPath" size="14" aria-hidden="true" />
          Atualizar
        </button>
      </div>
    </app-ui-page-header>
  } @else {
    <app-ui-empty-state
      compact
      title="Agente não encontrado"
      description="Verifique se o agente ainda existe ou volte para a listagem."
    />
  }

  @if (agent()) {
    <nav appRouteTabs aria-label="Seções do agente">
      @for (tab of tabs(); track tab.label) {
        @if (tab.path) {
          <a
            appRouteTabLink
            [routerLink]="tab.path"
            ariaCurrentWhenActive="page"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: tab.exact }"
          >
            <ng-icon [name]="tab.iconRef" size="14" aria-hidden="true" />
            {{ tab.label }}
          </a>
        }
      }
    </nav>

    <div appRouteTabPanel class="detail-tab-panel">
      <router-outlet />
    </div>
  }
</section>
